import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { freezerService } from "../services/freezerService";

// Thunks
export const fetchProductsByContainer = createAsyncThunk(
  "freezer/fetchProductsByContainer",
  async (containerId) => {
    const products = await freezerService.getProductsByContainer(containerId);
    return { containerId, products };
  }
);

export const addProduct = createAsyncThunk(
  "freezer/addProduct",
  async (productData) => {
    const product = await freezerService.addProduct(productData);
    return product;
  }
);

export const updateProduct = createAsyncThunk(
  "freezer/updateProduct",
  async ({ productId, updates }) => {
    const product = await freezerService.updateProduct(productId, updates);
    return product;
  }
);

export const deleteProduct = createAsyncThunk(
  "freezer/deleteProduct",
  async (productId) => {
    await freezerService.deleteProduct(productId);
    return productId;
  }
);

const freezerSlice = createSlice({
  name: "freezer",
  initialState: {
    productsByContainer: {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
    },
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Products
      .addCase(fetchProductsByContainer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductsByContainer.fulfilled, (state, action) => {
        state.loading = false;
        state.productsByContainer[action.payload.containerId] =
          action.payload.products;
      })
      .addCase(fetchProductsByContainer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Add Product
      .addCase(addProduct.fulfilled, (state, action) => {
        const containerId = action.payload.containerId;
        if (!state.productsByContainer[containerId]) {
          state.productsByContainer[containerId] = [];
        }
        state.productsByContainer[containerId].push(action.payload);
      })
      // Update Product
      .addCase(updateProduct.fulfilled, (state, action) => {
        const containerId = action.payload.containerId;
        const index = state.productsByContainer[containerId].findIndex(
          (p) => p._id === action.payload._id
        );
        if (index !== -1) {
          state.productsByContainer[containerId][index] = action.payload;
        }
      })
      // Delete Product
      .addCase(deleteProduct.fulfilled, (state, action) => {
        Object.keys(state.productsByContainer).forEach((containerId) => {
          state.productsByContainer[containerId] = state.productsByContainer[
            containerId
          ].filter((p) => p._id !== action.payload);
        });
      });
  },
});

export const { clearError } = freezerSlice.actions;
export default freezerSlice.reducer;
